import * as types from '../shared-store/actions/actionTypes'
import initialState from '../initialState'

export default function personLibraryReducer(state = initialState.personLibraryReducer, action) {
  switch (action.type) {
    case types.GET_PERSON_LIBRARY_CONTENT:
      return {
        ...state,
        page: action.page,
        loading: true
      }
    case types.RECEIVE_PERSON_LIBRARY_CONTENT:
      return {
        page: action.page,
        content: action.content,
        loading: false
      }
    case types.ERROR_GET_PERSON_LIBRARY_CONTENT:
      return {
        error: action.error,
        loading: false
      }
    default:
      return state
  }
}
